import DiscontinuedBadge from "./DiscontinuedBadge";

export default DiscontinuedBadge;
